import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "./reducers/modalConductor";
import appReducer from "./reducers/app";
import gamesReducer from "./reducers/games";
import picksReducer from "./reducers/picks";
import resultsReducer from "./reducers/results";

const preloadedState = {};

const store = configureStore({
  reducer: {
    app: appReducer,
    modal: modalReducer,
    games: gamesReducer,
    picks: picksReducer,
    results: resultsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  preloadedState,
});

export default store;
